/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Provider_AdsInputs */

const cs_integrations_provider_ads = /** @type {(inputs: Integrations_Provider_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads`)
};

const en_integrations_provider_ads = /** @type {(inputs: Integrations_Provider_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads`)
};

/**
* | output |
* | --- |
* | "Google Ads" |
*
* @param {Integrations_Provider_AdsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_provider_ads = /** @type {((inputs?: Integrations_Provider_AdsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Provider_AdsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_provider_ads(inputs)
	return cs_integrations_provider_ads(inputs)
});